<template>
  <div>
    <v-card class="ma-2 pt-0">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" md="2" class="pt-3 pl-2">
            <v-menu
            v-model="fromMenu"
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
                v-on="on"
                hide-details
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fromPicker"
              @input="fromMenu = false"
              color="primary"
            ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" md="2" class="pt-3 pl-2">
            <v-menu
            v-model="toMenu"
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
                v-on="on"
                hide-details
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="toPicker"
              @input="toMenu = false"
              color="primary"
            ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" md="2" class="pt-3 pl-2">
            <v-autocomplete
            label="Status"
            v-model="status"
            item-text="name"
            :items="statusList"
            return-object
            required
            hide-details
            name="statuslist"
            dense
          ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" class="pt-3 pl-2">
             <v-autocomplete
            label="Online Shopping"
            v-model="os"
            item-text="name"
            :items="osList"
            return-object
            required
            hide-details
            name="statuslist"
            dense
          ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" class="text-md-center text-right pt-2">
            <v-btn
              class="mr-1"
              fab
              small
              depressed
              color="primary"
              @click="search"
            >
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn class="ml-3" depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
    <v-row no-gutters>
          <v-col
            v-for="order in orderList"
            :key="order.itemId"
            cols="12"
            md="12"
            class="pl-1 pr-1"
          >
            <v-card class="ma-1">
              <v-card-text class="text--primary py-2">
                <v-row no-gutters>
                  <v-col cols="12" md="3">
                    <v-row no-gutters>
                  <v-col cols="12" md="12"><h4>Tracking Code : {{ order.itemCode }} (Id-{{order.itemId}})</h4></v-col>
                  <v-col cols="12" md="12">Order Date : {{ order.itemDate }}</v-col>
                  <v-col cols="12" md="12">Status : <v-btn class="red white--text" x-small> {{ order.status }}</v-btn></v-col>
                   <v-col cols="12" md="12">Pickup Date : {{ order.collectDate }}</v-col>
                   <v-col cols="12" md="12">Pickup By : <span class="primary--text">{{ order.collectName }}</span></v-col>
                   <v-col cols="12" md="12">Assigned Date : {{ order.assignDate }}</v-col>
                   <v-col cols="12" md="12">Assigned By : <span class="primary--text">{{ order.assignName }}</span></v-col>
                   <v-col cols="12" md="12">Delivered Date : {{ order.trDate }}</v-col>
                   <v-col cols="12" md="12">Message : {{ order.trRemark }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-row no-gutters>
                      <v-col cols="12" md="12" class="d-md-none"><v-divider /></v-col>
                  <v-col cols="12" md="12"><h4>Sender : {{ order.fromBranchName }}</h4></v-col>
                  <v-col cols="12" md="12">Name : {{ order.osName }}</v-col>
                  <v-col cols="12" md="12">Phone : {{ order.osPhone }}</v-col>
                   <v-col cols="12" md="12">Address : {{ order.osAddress }}</v-col>
                   <v-col cols="12" md="12" class="black--text "><h4>Charges</h4></v-col>
                   <v-col cols="12" md="12">Delivery Charges : {{ order.deliAmount }}</v-col>
                   <v-col cols="12" md="12">Item Value : {{ order.itemValue }}</v-col>
                   <v-col cols="12" md="12">Gate Charges : {{ order.gateAmount }}</v-col>
                   <v-col cols="12" md="12">Gate Detail : {{ order.gateRemark }}</v-col>
                   
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-row no-gutters>
                  <v-col cols="12" md="12"><h4>Receiver : {{ order.toTsName }}</h4></v-col>
                  <v-col cols="12" md="12">Name : {{ order.custName }}</v-col>
                  <v-col cols="12" md="12">Phone : {{ order.custPhone }}</v-col>
                   <v-col cols="12" md="12">Address : {{ order.custAddress }}</v-col>
                   <v-col cols="12" md="12" class="black--text "><h4> ..... </h4></v-col>
                   <v-col cols="12" md="12"><h4>Customer Charges :{{ order.totalCharges }} </h4></v-col>
                   <v-col cols="12" md="12">Customer Paid : {{ order.trpayment }}</v-col>
                   <v-col cols="12" md="12">Gate Paid : {{ order.gateReceive }}</v-col>
                    <v-col cols="12" md="12">OS Paid : {{ order.osPaid }}</v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-row no-gutters>
                      <v-col cols="12" md="12" class="d-md-none"><v-divider /></v-col>
                  <v-col cols="12" md="12"><h4>Item Name : {{ order.itemName }}</h4></v-col>
                  <v-col cols="12" md="12">Code : {{ order.itemCode }}</v-col>
                  <v-col cols="12" md="12">Weight : {{ order.itWeight }}</v-col>
                  <v-col cols="12" md="12" class="black--text "><h4>Tracking :</h4></v-col>
                  <v-col cols="12" md="12">Order Date : {{ order.itemDate }}</v-col>
                  <v-col cols="12" md="12">Pickup Date : {{ order.collectDate }}</v-col>
                  <v-col cols="12" md="12">Gate Date : {{ order.gateDate }}</v-col>
                  <v-col cols="12" md="12">Delivered Date : {{ order.trDate }}</v-col>
                  <v-col cols="12" md="12">Message : {{ order.trRemark }}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
  </div>
</template>
<script>
import onlineShopService from "../service/OnlineshoppingService";
import taskService from "../service/TaskService";
export default {
  data() {
    return {
      fromPicker: new Date().toISOString().substr(0, 10),
    toPicker: new Date().toISOString().substr(0, 10),
    fromMenu: false,
    toMenu: false,
    fromDate:"",
    toDate:"",
      statusList: [
        "ALL",
        "NONE",
        "COLLECTED",
        "ASSIGNED",
        "DELIVERED",
        "DELIVERING",
        "COMPLETED",
        "RETURN",
        "ERROR",
      ],
      status:"",
      osList:[],
      os:{},
      orderList:[],
      token:{}
    };
  },
   props: {},
  mounted: function () {
    this.token = this.$store.state.userAccount;
    this.fromDate = this.formatDate(this.fromPicker);
    this.toDate = this.formatDate(this.toPicker);
    this.status = this.statusList[0];
    this.osListMethod();
  },
  methods: {
    formatDate(fromPicker) {
      const [year, month, day] = fromPicker.split("-");
      return `${day}-${month}-${year}`;
    },
    osListMethod:function(){
      onlineShopService.getAllOnlineshopping().then((data) => {
        this.osList.push({ osId: 0, name: "All" });
        this.osList.push(...data);
      this.os = this.osList[0];
      this.search();
    });
    },
    search:function(){
taskService.searchOrderOs(this.fromDate,this.toDate,this.status,this.os.osId).then(
        (response)=>{
          this.orderList.splice(0,this.orderList.length);
          this.orderList.push(...response);
        }
      ).catch((err) => {
            this.$swal("Failed", err.response.data.message, "error");
          });
    }
  },
    watch: {
    fromPicker() {
      this.fromDate = this.formatDate(this.fromPicker);
    },
    toPicker() {
      this.toDate = this.formatDate(this.toPicker);
    },
    
  },
  computed: { },
};
</script>
